<template>
  <div class="line-item-editor">
    <a
      class="btn btn--discrete btn--smallest choosable-gift__btn modal-velociraptor-trigger"
      @click.prevent="openModal"
    >
      {{
        isPresent(lineItem.customizations)
          ? $t(
              lineItem.sku.match('lineart')
                ? 'change_customization_lineart'
                : 'change_customization'
            )
          : $t('edit_product')
      }}
    </a>

    <modal
      class="line-item-editor__modal"
      :open="isModalOpen"
      @close="toogleModal('close')"
    >
      <template v-slot:title>
        {{
          isPresent(lineItem.customizations)
            ? $t('change_customization')
            : $t('edit_product')
        }}
      </template>

      <div class="line-item-editor__content">
        <div class="line-item-editor__content-loading">
          <logo-loading v-show="isLoading" />
        </div>

        <product-editor
          v-if="product && product.line_item_id === lineItem.id"
          :product="product"
          :product-stock="productStock"
          :gallery-items="galleryItems"
          :line-item-editor="true"
          :line-item-id="lineItem.id"
          :is-gift="lineItem.gift"
          :my-order-number="orderNumber"
          :editable-order-product="editableOrderProduct"
          @updatedLineItem="updatedLineItem"
          @productFormLoaded="isLoading = false"
        />
      </div>
    </modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import isPresent from '@/utils/isPresent'
import ProductEditor from '~/components/product/product-editor/ProductEditor.vue'
import Modal from '~/components/Modal.vue'
import LogoLoading from '~/components/loadings/logo'

export default {
  components: {
    ProductEditor,
    Modal,
    LogoLoading,
  },
  props: {
    lineItem: {
      type: Object,
      required: true,
    },
    editableOrderProduct: {
      type: Boolean,
      default: false,
    },
    orderNumber: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      isModalOpen: false,
      isLoading: true,
      productStock: null,
    }
  },
  computed: {
    ...mapState({
      product: (state) => state.product.product,
    }),
    ...mapGetters({ galleryItems: 'product/galleryItems' }),
  },
  watch: {
    async isModalOpen(isOpen) {
      if (isOpen) {
        const params = {
          ...this.$store.getters.storeInfo,
          line_item_id: this.lineItem.id,
          number: this.orderNumber,
        }
        try {
          const baseUrl = this.editableOrderProduct
            ? 'orders/edit_line_item'
            : 'carts/edit_line_item'

          const product = await this.$axios.$get(baseUrl, {
            params,
          })

          const productStock = await this.$axios.$get(
            `/products/${product.slug}/stock`,
            {
              params,
            }
          )

          this.$store.dispatch('product/setProduct', product)
          this.$store.dispatch('product/setProductStock', productStock)
          this.productStock = productStock
        } catch (err) {
          this.$displayTopMessage(this.$t('action_error'), {
            type: 'error',
          })
        }
      } else {
        this.$store.dispatch('product/setProduct', null)
      }
    },
  },
  methods: {
    isPresent,
    updatedLineItem() {
      this.toogleModal('close')
      this.$emit('updatedLineItem')
    },
    toogleModal(status) {
      if (status === 'open') {
        this.isModalOpen = true
      } else {
        this.isModalOpen = false
      }
    },
    openModal() {
      this.$store.dispatch?.('analytics/emitGtagEvent', {
        name: 'click_item_edit',
      })
      this.toogleModal('open')
    },
  },
}
</script>

<style lang="scss">
@import '~/assets/css/btn.scss';

.line-item-editor {
  display: inline-block;
  margin-top: 10px;
}

.line-item-editor__modal {
  .add-to-cart__casedevice {
    margin-bottom: 15px;
  }
}

.line-item-editor__content {
  @media (min-width: 1200px) {
    margin-right: 50px;
    margin-top: 30px;
  }
}

.line-item-editor__content-loading {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (min-width: $v4_desktop) {
  .line-item-editor {
    .productpage__wrapper {
      position: relative;
      margin-top: 10px;
      margin-left: 0;
      margin-right: 0;
    }
    .productpage__details {
      margin-left: 600px;
    }
  }
}
</style>
